(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heeposh-product-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function (event) {
    var openButton = event.target.closest('[data-heeposh-offers-open]');
    if (openButton) {
      var dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    var closeButton = event.target.closest('[data-heeposh-offers-close]');
    if (closeButton) {
      closeButton.closest('dialog').close();
      return;
    }
    var copyButton = event.target.closest('[data-heeposh-offers-copy]');
    if (copyButton) {
      try {
        await navigator.clipboard.writeText(copyButton.dataset.code);
        copyButton.textContent = copyButton.dataset.copiedLabel;
        window.setTimeout(function () { copyButton.textContent = copyButton.dataset.copyLabel; }, 2000);
      } catch (error) {
        copyButton.focus();
      }
      return;
    }
    if (event.target.matches('.heeposh-offers__dialog')) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
